export function authErrorMessage(error) {
  switch (error?.code) {
    case 'auth/invalid-credential':
    case 'auth/user-not-found':
    case 'auth/wrong-password': return 'Email or password is incorrect. Try again or reset your password.';
    case 'auth/invalid-email': return 'Enter a valid email address.';
    case 'auth/email-already-in-use': return 'This email is already registered. Sign in or reset your password to recover your account.';
    case 'auth/weak-password':
    case 'auth/password-does-not-meet-requirements': return 'This password does not meet the requirements. Use a longer password with uppercase and lowercase letters, a number, and a symbol.';
    case 'auth/network-request-failed': return 'Check your internet connection and try again.';
    case 'auth/too-many-requests':
    case 'auth/quota-exceeded': return 'Too many attempts. Please wait and try again.';
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request': return 'Google sign-in was cancelled. You can try again.';
    case 'auth/popup-blocked': return 'Allow pop-ups for this site, then try Google sign-in again.';
    case 'auth/account-exists-with-different-credential': return 'This email uses another sign-in method. Sign in with that method, or reset your password.';
    case 'auth/operation-not-allowed': return 'This sign-in method is not enabled. Please contact support.';
    case 'auth/unauthorized-domain': return 'Sign-in is not enabled for this website address. Please contact support.';
    case 'auth/user-disabled': return 'This account is disabled. Please contact support.';
    case 'auth/session-changed': return 'Your signed-in account changed. Please reload before continuing.';
    default: return 'Unable to complete this request. Please try again.';
  }
}
